import React from 'react';
import { Box, TextField, IconButton, Tooltip, InputAdornment } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import MicIcon from '@mui/icons-material/Mic';
import StopIcon from '@mui/icons-material/Stop';

const ChatInput = ({ input, setInput, onSend, listening, onMicClick, loading, onInputKeyDown }) => (
  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
    <TextField
      fullWidth
      variant="outlined"
      placeholder="Type a message..."
      value={input}
      onChange={e => setInput(e.target.value)}
      onKeyDown={onInputKeyDown}
      disabled={loading}
      size="small"
      sx={{
        '& .MuiOutlinedInput-root': {
          borderRadius: 3,
          bgcolor: 'white',
          pr: 1
        }
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <Tooltip title={listening ? 'Stop Listening' : 'Speak'}>
              <span>
                <IconButton 
                  color={listening ? 'error' : 'default'} 
                  onClick={onMicClick} 
                  disabled={loading}
                  edge="end"
                  size="small"
                >
                  {listening ? <StopIcon /> : <MicIcon />}
                </IconButton>
              </span>
            </Tooltip>
          </InputAdornment>
        )
      }}
    />
    <Box 
      sx={{ 
        bgcolor: input.trim() ? 'primary.main' : 'action.disabledBackground',
        borderRadius: '50%',
        width: 40,
        height: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'background-color 0.2s'
      }}
    >
      <IconButton 
        onClick={onSend} 
        disabled={loading || !input.trim()}
        sx={{ color: 'white' }}
        size="small"
      >
        <SendIcon fontSize="small" />
      </IconButton>
    </Box>
  </Box>
);

export default ChatInput;
